import DatabaseModel from './DatabaseModel.js';
import CacheService from './Cache.js';


const Factura = {
    ...DatabaseModel,
    model: 'factura',
    modelFront: 'facturas',

    crearFacturas(params) {
        const self = this;
        params = params || {};
        const requestParams = {
            url: self.server_movilidad + self.prefix + self.model + '/lineas',
            method: 'POST',
            data: params.data
        };
        return self.sendRequest(requestParams, false).then(function(res) {
            return res;
        });
    },

    marcarCobrada(params) {
        const self = this;
        params = params || {};
        if (!params.itemId) reject({ error: 'itemId not defined' });
        const requestParams = {
            url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/marcarCobrada',
            method: 'PUT',
            data: params.data
        };
        return self.sendRequest(requestParams, false).then(function(res) {
            CacheService.clearCache(self.model);
            return res;
        });
    },
    // La cancelación de la factura la marcará como cancelada y creará un abono
    cancelar(params) {
        const self = this;
        params = params || {};
        const requestParams = {
            url: self.server_movilidad + self.prefix + self.model + '/cancelar',
            method: 'POST',
            data: params.data
        };
        return self.sendRequest(requestParams, false).then(function(res) {
            // CacheService.clearCache(self.model);
            return res;
        });
    },

    asignaDocumentoFactura(params) {
        const self = this;
        params = params || {};
        if (!params.itemId) reject({ error: 'itemId not defined' });
        const requestParams = {
            url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/asignaDocumentoFactura',
            method: 'PUT',
            data: params.data
        };
        return self.sendRequest(requestParams, false).then(function(res) {
            CacheService.clearCache(self.model);
            return res;
        });
    },

    certificadosPorFacturas(data) {
        const self = this;
        const params = {
            url: self.server_movilidad + self.prefix + self.model + '/certificados-por-facturas/',
            method: 'POST',
            data: data
        };
        return self.sendRequest(params, false).then(function(res) {
            return res;
        });
    },

    enviarEmail(data) {
        const self = this;
        const params = {
            url: self.server_movilidad + self.prefix + self.model + '/enviarEmail/',
            method: 'POST',
            data: data
        };
        return self.sendRequest(params, false).then(function(res) {
            return res;
        });
    },

    crearPDF(data) {
        const self = this;
        const params = {
            url: self.server_movilidad + self.prefix + self.model + '/crearPDF/',
            method: 'POST',
            data: data
        };
        return self.sendRequest(params, false).then(function(res) {
            return res;
        });
    },

    asociarDocumentoFactura(data) {
        const self = this;
        const params = {
            url: self.server_movilidad + self.prefix + self.model + '/asociarDocumentoFactura/',
            method: 'POST',
            data: data
        };
        return self.sendRequest(params, false).then(function(res) {
            return res;
        });
    },

    eliminaDocumentoFactura(data) {
        const self = this;
        const params = {
            url: self.server_movilidad + self.prefix + self.model + '/eliminaDocumentoFactura/',
            method: 'PUT',
            data: data
        };
        return self.sendRequest(params, false).then(function(res) {
            return res;
        });
    }
};

export default Factura;